module.exports = __webpack_public_path__ + "img/schedule.c657de69.svg";